import { SafeInlineText } from "../ui/RichTextEditor";
type PolicyDocumentProps = {
  body: string;
  className?: string;
};

type Block =
  | { kind: "heading"; level: 2 | 3; text: string }
  | { kind: "paragraph"; text: string }
  | { kind: "list"; ordered: boolean; items: string[] };

function blocks(body: string): Block[] {
  const result: Block[] = [];
  let paragraph: string[] = [];
  let list: string[] = [];
  let ordered = false;

  function flushParagraph() {
    if (!paragraph.length) return;
    result.push({ kind: "paragraph", text: paragraph.join(" ").trim() });
    paragraph = [];
  }

  function flushList() {
    if (!list.length) return;
    result.push({ kind: "list", ordered, items: list });
    list = [];
  }

  for (const rawLine of body.replace(/\r\n?/g, "\n").split("\n")) {
    const line = rawLine.trim();
    if (!line) {
      flushParagraph();
      flushList();
      continue;
    }
    if (line.startsWith("## ")) {
      flushParagraph();
      flushList();
      result.push({ kind: "heading", level: 3, text: line.slice(3).trim() });
      continue;
    }
    if (line.startsWith("# ")) {
      flushParagraph();
      flushList();
      result.push({ kind: "heading", level: 2, text: line.slice(2).trim() });
      continue;
    }
    if (line.startsWith("- ") || /^\d+\.\s+/.test(line)) {
      flushParagraph();
      const nextOrdered = !line.startsWith("- ");
      if (list.length && nextOrdered !== ordered) flushList();
      ordered = nextOrdered;
      list.push(line.replace(/^(?:-\s+|\d+\.\s+)/, "").trim());
      continue;
    }
    flushList();
    paragraph.push(line);
  }
  flushParagraph();
  flushList();
  return result;
}

export function PolicyDocument({ body, className = "" }: PolicyDocumentProps) {
  return <div className={`policy-document ${className}`.trim()}>
    {blocks(body).map((block, index) => {
      if (block.kind === "heading") {
        return block.level === 2
          ? <h2 key={`${block.text}-${index}`}><SafeInlineText value={block.text} /></h2>
          : <h3 key={`${block.text}-${index}`}><SafeInlineText value={block.text} /></h3>;
      }
      if (block.kind === "list") {
        const List = block.ordered ? "ol" : "ul";
        return <List key={`list-${index}`}>{block.items.map((item, itemIndex) => <li key={itemIndex}><SafeInlineText value={item} /></li>)}</List>;
      }
      return <p key={`paragraph-${index}`}><SafeInlineText value={block.text} /></p>;
    })}
  </div>;
}
